import { Map } from 'immutable';
import { actionTypes as CreatePartTypeDialogActionsTypes } from '../../../actions/Administration/MatSettingsPage/Dialogs/createPartTypeDialogActions.js';

let defaultState = {
  show: false,
  loading: false,
  itemToEdit: null,
  dialogData: []
};

export default function(state = Map(defaultState), action) {

  switch (action.type) {
    case CreatePartTypeDialogActionsTypes.CREATE_PARTTYPE_DIALOG_SHOW:
      state = state.set('itemToEdit', action.payload);
      return state.set('show',true);

    case CreatePartTypeDialogActionsTypes.CREATE_PARTTYPE_DIALOG_HIDE:
      return Map(defaultState);

    case CreatePartTypeDialogActionsTypes.CREATE_PARTTYPE_DIALOG_SUBMIT_IN_PROGRESS:
      return state.set("loading", true);

    case CreatePartTypeDialogActionsTypes.CREATE_PARTTYPE_DIALOG_SUBMIT_FINISHED:
      return state.set("loading", false);

    case CreatePartTypeDialogActionsTypes.CREATE_PARTTYPE_DIALOG_FETCH_DATA_READY:
      return state.set("dialogData", action.payload);

    default:
      return state;
  }

}







